module.exports = __webpack_public_path__ + "static/media/biteship-woo-checkout.427a8ef4.png";